<script lang="ts">
  import { onMount, createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher<{highlight:{startRow:number, startColumn:number, endRow:number, endColumn:number}}>()
  export let syntaxError:SyntaxError;
  let column:number;
  let row:number;
  $: message = syntaxError.message.slice(0, syntaxError.message.lastIndexOf("(") - 1);
  $: {
    let regex = /\((\d+:\d+)\)$/g;
    let result:RegExpMatchArray | null = syntaxError.message.match(regex);
    if (result) {
      let columnLineText:string = result[0]
      let colonIndex:number = columnLineText.indexOf(":");
      row = parseInt(columnLineText.slice(1, colonIndex));
      column = parseInt(columnLineText.slice(colonIndex + 1, columnLineText.length - 1));
    }    
  }

  onMount(()=>{
    onClick()
  });

  function onClick() {
    dispatch("highlight", {startRow:row-1, startColumn:column, endRow:row-1, endColumn:column+1});
  }
</script>

<div class="text-darkFore bg-darkBack">
  <div><span class="text-red">☒ Syntax Error </span>{message} <button class="text-blue underline" on:click={onClick}>({row + ":" + column})</button></div>
</div>
